<template>
  <el-row>
    <el-col :span="24">
      <div class="gs-menu">
        <el-menu background-color="#324057" text-color="#fff" active-text-color="#FACE68" :default-active="active"
          mode="horizontal" router>
          <el-menu-item index="dashboard" :route="{ name: 'dashboard' }" class="gs-logo gs-border-none">ONX
            CMS</el-menu-item>
          <el-menu-item index="price-table" :route="{ name: 'price-table' }">Bảng giá</el-menu-item>
          <el-menu-item index="promotions" :route="{ name: 'promotion' }">Mã giảm giá</el-menu-item>
          <el-menu-item index="blocks" :route="{ name: 'blocks' }">Chặn tuyến đường</el-menu-item>
          <el-submenu index="services-group">
            <template slot="title"><span style="font-size: 15px">Dịch vụ</span></template>
            <el-menu-item index="services" :route="{ name: 'services' }">
              <i class="fa fa-list-alt"></i> Dịch vụ
            </el-menu-item>
            <el-menu-item index="check-ghn-service" :route="{ name: 'check-ghn-service' }">
              <i class="fa fa-check"></i> CheckGHNService
            </el-menu-item>
            <el-menu-item index="bank" :route="{ name: 'bank' }">
              <i class="fa fa-university"></i> Ngân hàng
            </el-menu-item>
          </el-submenu>
          <el-menu-item index="carriers" :route="{ name: 'carrier' }">Hãng vận chuyển</el-menu-item>
          <el-submenu index="locations-group">
            <template slot="title"><span style="font-size: 15px">Địa điểm</span></template>
            <el-menu-item index="regions" :route="{ name: 'region' }">
              <i class="fa fa-map-marker" aria-hidden="true"></i> Vùng miền
            </el-menu-item>
            <el-menu-item index="cities" :route="{ name: 'city' }">
              <i class="fa fa-map-marker" aria-hidden="true"></i> Tỉnh thành
            </el-menu-item>
            <el-menu-item index="districts" :route="{ name: 'district' }">
              <i class="fa fa-map-marker" aria-hidden="true"></i> Quận huyện
            </el-menu-item>
            <el-menu-item index="wards" :route="{ name: 'ward' }">
              <i class="fa fa-map-marker" aria-hidden="true"></i> Phường xã
            </el-menu-item>
            <el-menu-item index="addresses" :route="{ name: 'address' }">
              <i class="fa fa-map-marker" aria-hidden="true"></i> Địa chỉ
            </el-menu-item>
            <el-menu-item index="post-offices" :route="{ name: 'post-offices' }">
              <i class="fa fa-location-arrow" aria-hidden="true"></i> Bưu cục
            </el-menu-item>
          </el-submenu>
          <el-submenu index="news-group">
            <template slot="title"><span style="font-size: 15px">Tin tức</span></template>
            <el-menu-item index="blogs" :route="{ name: 'blog' }">
              <i class="fa fa-rss" aria-hidden="true"></i> Bài viết
            </el-menu-item>
            <el-menu-item index="categories" :route="{ name: 'category' }">
              <i class="fa fa-th-list" aria-hidden="true"></i> Danh mục
            </el-menu-item>
          </el-submenu>
          <div class="header-right gs-border-none pull-right padding-right padding-left">
            <el-dropdown>
              <span class="el-dropdown-link">
                <i class="el-icon-setting icon-header"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                  <a @click.prevent="logOut()" class="text-blue"><i class="fa fa-sign-out" aria-hidden="true"></i> Đăng
                    xuất</a>
                </el-dropdown-item>
                <el-dropdown-item>
                  <a @click.prevent="changePassword()" class="text-blue"><i class="fa fa-key" aria-hidden="true"></i>
                    Đổi mật
                    khẩu</a>
                </el-dropdown-item>
                <el-dropdown-item>
                  <a @click.prevent="$router.push({ name: 'setting' })" class="text-blue text-remove-decoration">
                    <i class="fa fa-cogs"></i> Cấu hình cài đặt
                  </a>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="header-right gs-border-none pull-right padding-right padding-left">
            <el-popover ref="popover" width="200" trigger="hover">
              <h3 class="text-center text-blue remove-margin">Thông tin tài khoản</h3>
              <p><i class="fa fa-user"></i> {{ accountInfo.name }}</p>
              <p><i class="fa fa-phone"></i> {{ accountInfo.phone }}</p>
              <p><i class="fa fa-envelope-o"></i> {{ accountInfo.email }}</p>
            </el-popover>
            <i class="fa fa-user-circle-o icon-header" v-popover:popover></i>
          </div>
        </el-menu>
        <el-dialog title="Đổi mật khẩu" :visible.sync="changePasswordModal">
          <el-form :rules="rules" ref="changePasswordForm" :model="account" label-width="120px"
            @submit.prevent.native="validateBeforeSubmit" label-position="top">
            <el-form-item label="Mật khẩu hiện tại" class="padding-login-item" prop="old_password">
              <el-input type="password" v-model="account.old_password" placeholder="Mật khẩu hiện tại"></el-input>
            </el-form-item>
            <el-form-item label="Mật khẩu mới" class="padding-login-item" prop="password">
              <el-input type="password" v-model="account.password" placeholder="Mật khẩu mới"></el-input>
            </el-form-item>
            <el-form-item label="Nhập lại mật khẩu" prop="password_confirmation">
              <el-input type="password" v-model="account.password_confirmation"
                placeholder="Nhập lại mật khẩu"></el-input>
            </el-form-item>
            <el-form-item class="padding-login-item">
              <el-button type="primary" native-type="submit" class="width-100"><i class="fa fa-floppy-o"></i> Lưu
                lại</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import { changePassword } from 'src/api/accounts'
import { head } from 'lodash'
import { mapGetters, mapActions } from 'vuex'
export default {

  name: 'GsMenu',

  data() {
    let comfirmPass = (rule, value, callback) => {
      if (value !== this.account.password) {
        callback(new Error('Nhập lại mật khẩu không đúng'))
      } else {
        callback()
      }
    }
    return {
      active: 'price-table',
      changePasswordModal: false,
      account: {
        old_password: '',
        password: '',
        password_confirmation: ''
      },
      rules: {
        old_password: [
          {
            required: true,
            message: 'Mật khẩu hiện tại không được để trống',
            trigger: 'change'
          },
          {
            min: 6,
            max: 32,
            message: 'Mật khẩu hiện tại phải trong khoảng 6 đến 32 ký tự',
            trigger: 'change'
          }
        ],
        password: [
          {
            required: true,
            message: 'Mật khẩu mới không được để trống',
            trigger: 'change'
          },
          {
            min: 6,
            max: 32,
            message: 'Mật khẩu mới phải trong khoảng 6 đến 32 ký tự',
            trigger: 'change'
          }
        ],
        password_confirmation: [
          {
            required: true,
            message: 'Nhập lại mật khẩu không được để trống',
            trigger: 'change'
          },
          {
            validator: comfirmPass,
            trigger: 'change'
          }
        ]
      }
    }
  },
  computed: {
    ...mapGetters('account', ['accountInfo'])
  },
  methods: {
    ...mapActions('account', ['getPersonlInformation']),
    handleSelectClick(ev) {
    },
    validateBeforeSubmit() {
      this.$refs.changePasswordForm.validate(valid => {
        if (valid) {
          changePassword(this.account).then(response => {
            if (response.code === 200) {
              this.$store.dispatch('showNotify', {
                title: 'Đổi mật khẩu thành công',
                body: 'Đổi mật khẩu thành công'
              })
              this.$store.dispatch('logout')
              this.$router.push({ path: '/login' })
            }
            if (response.code === 422) {
              let er = response.data.errors
              let message = head(er)
              this.$store.dispatch('showNotify', {
                title: 'Vui lòng kiểm tra thông tin cần nhập',
                body: message,
                type: 'warning'
              })
              this.submitting = false
            }
          })
        } else {
          this.$store.dispatch('showNotify', {
            title: 'Vui lòng kiểm tra thông tin cần nhập',
            type: 'warning'
          })
          this.submitting = false
          return false
        }
      })
    },
    logOut() {
      this.$store.dispatch('logout')
      this.$router.push('/login')
      window.location.reload()
    },
    changePassword() {
      this.changePasswordModal = true
    },
    updateActiveMenu(route) {
      if (route.name === 'dashboard') {
        this.active = 'price-table'
      } else {
        this.active = route.fullPath.split('/')[1] || 'price-table'
      }
    }
  },
  mounted() {
    this.updateActiveMenu(this.$route)
    if (!Object.keys(this.accountInfo).length) {
      this.getPersonlInformation()
    }
  },
  watch: {
    '$route'(to) {
      this.updateActiveMenu(to)
    }
  }
}
</script>

<style lang="css" scoped>
.gs-menu .el-menu {
  padding: 0 70px;
  border-radius: 0;
}

.gs-logo {
  font-size: 20px;
  color: #c0ccda;
  padding-right: 120px;
  padding-left: 15px;
}

.el-menu--horizontal>.gs-border-none:hover {
  border-bottom: transparent;
}

.input-search {
  width: 280px !important;
  height: 36px;
}

.icon-header {
  color: #fff;
  font-size: 20px;
  cursor: pointer;
}

.header-right {
  height: 60px;
  line-height: 60px;
}
</style>



// WEBPACK FOOTER //
// GsMenu.vue?39ff685e